"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SiteNewToSimilar_1 = require("../model/SiteNewToSimilar");

var SiteNewToSimilarConverter_1 = require("./SiteNewToSimilarConverter");
/**
 * Default implementation of {@link SiteNewToSimilarConverter}.
 *
 * @author Radek Beran
 */


var SiteNewToSimilarConverterImpl =
/*#__PURE__*/
function (_SiteNewToSimilarConv) {
  _inherits(SiteNewToSimilarConverterImpl, _SiteNewToSimilarConv);

  function SiteNewToSimilarConverterImpl() {
    _classCallCheck(this, SiteNewToSimilarConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteNewToSimilarConverterImpl).apply(this, arguments));
  }

  _createClass(SiteNewToSimilarConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SiteNewToSimilar_1.SiteNewToSimilar(SiteNewToSimilar_1.SiteNewToSimilar.schema.id.valueOf(conversions.documentToClassId(source)), SiteNewToSimilar_1.SiteNewToSimilar.schema.newSiteId.valueOf(conversions.toClassReferenceId(source.newSiteId)), SiteNewToSimilar_1.SiteNewToSimilar.schema.similarSiteId.valueOf(conversions.toClassReferenceId(source.similarSiteId)), SiteNewToSimilar_1.SiteNewToSimilar.schema.activationTime.valueOfField(source), conversions.asObjectList(source, 'exportTimes', function (doc) {
        return conversions.toDate(doc);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        newSiteId: conversions.toDocumentReferenceId(source.newSiteId),
        similarSiteId: conversions.toDocumentReferenceId(source.similarSiteId),
        activationTime: conversions.fromDate(source.activationTime),
        exportTimes: source.exportTimes.map(function (t) {
          return conversions.fromDate(t);
        }).toArray()
      });
      return result;
    }
  }]);

  return SiteNewToSimilarConverterImpl;
}(SiteNewToSimilarConverter_1.SiteNewToSimilarConverter);

exports.SiteNewToSimilarConverterImpl = SiteNewToSimilarConverterImpl;